<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  (selectedTabChange)="onTabChange($event)"
>
  @if(carePathwaySteps.length > 0) {
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon fontSet="material-symbols-outlined" class="tab-icon">
        polyline
      </mat-icon>
      <span>Parcours de soins</span>
    </ng-template>
    @if(selectedCarePathwayStepIndex == null) {
    <app-care-pathway [carePathwaySteps]="carePathwaySteps"></app-care-pathway>
    }@else {
    <app-care-pathway-step
      [stepIndex]="selectedCarePathwayStepIndex"
      [allSteps]="carePathwaySteps"
    ></app-care-pathway-step>
    }
  </mat-tab>
  } @if(categories.length >0) { @for(cat of categories; track $index) {
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon fontSet="material-symbols-outlined" class="tab-icon">
        {{ cat.matIcon }}
      </mat-icon>
      <span>{{ cat.name }}</span>
    </ng-template>
    <app-result-category-view
      [category]="cat"
      [timeHorizon]="timeHorizon"
    ></app-result-category-view>
  </mat-tab>
  } } @if (summaryItems.length > 0) {
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon fontSet="material-symbols-outlined" class="tab-icon">
        data_check
      </mat-icon>
      <span>Synthèse</span>
    </ng-template>
    <app-summary [items]="summaryItems"></app-summary>
  </mat-tab>
  }
</mat-tab-group>
